import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import livretKeys from './keys';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';

interface UpdateLivretEvalCompNumeriqueDTO {
  id: string;
  niveau: number;
  code: string;
}

function updateLivretEvalCompNumerique({
  schoolyearId,
  schoolId,
  livretEvalId,
  code,
  niveau,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEvalId: string;
  code: string;
  niveau: number;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets/${livretEvalId}/comp-numeriques`;
  return request(requestURL, {
    method: 'PATCH',
    body: {
      code,
      niveau,
    },
  });
}

export function useUpdateLivretEvalCompNumerique() {
  const { notifyError, notifySuccess } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['carnet']);
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: (payload: UpdateLivretEvalCompNumeriqueDTO) =>
      updateLivretEvalCompNumerique({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEvalId: payload.id,
        code: payload.code,
        niveau: payload.niveau,
      }),

    onSuccess: () => {
      notifySuccess({
        title: t('carnet:messages.livret.updateSuccess'),
      });
      queryClient.invalidateQueries({
        queryKey: livretKeys.all(schoolyear.id, school.id),
      });
    },
    onError: () => {
      notifyError({
        title: t('carnet:messages.livret.updateError'),
      });
    },
  });
  return { updateLivretEvalCompNumerique: mutateAsync, isLoading };
}
